import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "swt-footer",
  class: "bg-black-alpha-90 text-white flex flex-col gap-y-36 px-28 py-12"
}
const _hoisted_2 = {
  id: "footer-1",
  class: "flex justify-center align-items-center flex-col gap-5"
}
const _hoisted_3 = { class: "flex gap-2 align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl font-semibold text-white" }, "SAWE-T", -1)
const _hoisted_5 = {
  id: "footer-links",
  class: "flex gap-x-8 text-white"
}
const _hoisted_6 = {
  id: "footer-2",
  class: "flex justify-between align-items-center"
}
const _hoisted_7 = { href: "https://www.linkedin.com/company/safemar" }

import Button from 'primevue/button'
import SawetLogo from '@/components/SawetLogo/SawetLogo.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'LandingFooter',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SawetLogo, {
          width: 40,
          height: 40
        }),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/",
          target: "_self",
          rel: "noopener"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              label: "Overview",
              link: "",
              class: "text-white font-semibold"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/careers",
          target: "_self",
          rel: "noopener"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              label: "Careers",
              link: "",
              class: "text-white font-semibold"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/privacy",
          target: "_self",
          rel: "noopener"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              label: "Privacy policy",
              plain: "",
              link: "",
              class: "text-white font-semibold"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", null, " © " + _toDisplayString(new Date().getFullYear().toString()) + " Intranovum Limited. All rights reserved. ", 1),
      _createElementVNode("span", null, [
        _createElementVNode("a", _hoisted_7, [
          _createVNode(_unref(Button), {
            label: "Follow us",
            icon: "pi pi-linkedin",
            link: "",
            class: "text-white"
          })
        ])
      ])
    ])
  ]))
}
}

})